import type { UserRole } from '@/types';

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  WORKSPACE: '/workspace',
  NOVICE_WORKSPACE: '/user/novice/workspace',
  OPERATOR_WORKSPACE: '/user/operator/workspace',
  NOVICE_CONVERSATIONS: '/user/novice/conversations',
  OPERATOR_CONVERSATIONS: '/user/operator/conversations',
  CONVERSATIONS: '/conversations',
  SAVED_ACTIONS: '/saved-actions',
  SETTINGS: '/settings',
} as const;

export function conversationsBase(role: UserRole): string {
  return role === 'operator' ? ROUTES.OPERATOR_CONVERSATIONS : ROUTES.NOVICE_CONVERSATIONS;
}

export function conversationPath(conversationId: string, role: UserRole = 'novice'): string {
  return `${conversationsBase(role)}/${conversationId}`;
}

export function conversationPathWithWorkflow(
  conversationId: string,
  workflow: 'device-setup',
  role: UserRole = 'novice'
): string {
  return `${conversationPath(conversationId, role)}?workflow=${workflow}`;
}

export type Route = (typeof ROUTES)[keyof typeof ROUTES];
